var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { Svg } from './Svg';
var ArrowPointDownRightIcon = function (_a) {
    var fillColor = _a.fillColor, props = __rest(_a, ["fillColor"]);
    return (React.createElement(Svg, __assign({}, props),
        React.createElement("g", null,
            React.createElement("path", { d: "M23.9997873,11.020211 C23.9999289,11.0267913 24,11.0333879 24,11.04 C24,11.3600007 23.833437,11.6434327 23.5773608,11.8178692 L18.648241,16.7188225 C18.2711831,17.0937258 17.6598514,17.0937258 17.2827935,16.7188225 C16.9057355,16.3439192 16.9057355,15.7360808 17.2827935,15.3611775 L20.6632881,12 L2.55319149,12 C1.14310277,12 1.95399252e-13,10.9254834 1.95399252e-13,9.6 L1.95399252e-13,0.96 C1.95399252e-13,0.42980664 0.457241107,0 1.0212766,0 C1.58531208,0 2.04255319,0.42980664 2.04255319,0.96 L2.04255319,9.6 C2.04255319,9.86509668 2.27117374,10.08 2.55319149,10.08 L20.7437478,10.08 L17.2827935,6.63882251 C16.9057355,6.26391919 16.9057355,5.65608081 17.2827935,5.28117749 C17.6598514,4.90627417 18.2711831,4.90627417 18.648241,5.28117749 L23.7172065,10.3211775 C23.9109055,10.5137696 24.0050991,10.7678332 23.9997873,11.020211 Z" }))));
};
export var ArrowPointDownRight = styled(ArrowPointDownRightIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
//# sourceMappingURL=ArrowPointDownRight.js.map